import React from "react";
import { motion } from "framer-motion";

const container = (stagger, delay) => ({
  hidden: {},
  show: { transition: { staggerChildren: stagger, delayChildren: delay } },
});

const word = {
  hidden: { y: "115%" },
  show: { y: 0, transition: { duration: 0.95, ease: [0.16, 1, 0.3, 1] } },
};

/**
 * Apple-style word-by-word mask reveal. Each word rises from behind a clip mask.
 * `as` controls the wrapping tag (h1/h2/span). `trigger` = "view" | "mount".
 */
export const KineticHeading = ({
  text,
  className = "",
  as = "h2",
  stagger = 0.07,
  delay = 0,
  trigger = "view",
}) => {
  const Comp = motion[as] || motion.h2;
  const words = String(text).split(" ");
  const animateProps =
    trigger === "mount"
      ? { animate: "show" }
      : { whileInView: "show", viewport: { once: true, margin: "-12%" } };

  return (
    <Comp className={className} variants={container(stagger, delay)} initial="hidden" {...animateProps}>
      {words.map((w, i) => (
        <span key={i} className="inline-block overflow-hidden align-bottom pb-[0.12em] -mb-[0.12em]">
          <motion.span variants={word} className="inline-block" style={{ willChange: "transform" }}>
            {w}
            {i < words.length - 1 ? "\u00A0" : ""}
          </motion.span>
        </span>
      ))}
    </Comp>
  );
};
